// extracted by mini-css-extract-plugin
export default {"selectWrapper":"Select_selectWrapper__vJNtP","select":"Select_select__03Xiw","searchIcon":"Select_searchIcon__hb4BZ","withoutSearchIcon":"Select_withoutSearchIcon__F70A5"};